module.exports = __webpack_public_path__ + "static/media/nami-win.a30dd3a9.png";